<template>
    <div class="fixed top-0 right-0 z-30 m-6">
        <transition name="slide-fade">
            <div
                v-if="$page.props.flash.success && show"
                class="flex items-center justify-between max-w-3xl bg-green-500 rounded-lg"
                @click="show = false"
            >
                <div class="flex w-full max-w-sm mx-auto overflow-hidden bg-white rounded-lg shadow-md dark:bg-gray-800">
                    <div class="flex items-center justify-center w-12 bg-green-500">
                        <SuccessIcon class="w-6 h-6 text-white fill-current" />
                    </div>

                    <div class="px-4 py-2 -mx-3">
                        <div class="mx-3">
                            <span class="font-semibold text-green-500 dark:text-green-400">Success</span>
                            <p class="text-sm text-gray-600 dark:text-gray-200">
                                {{ $page.props.flash.success }}
                            </p>
                        </div>
                    </div>
                </div>
            </div>

            <div
                v-if="($page.props.flash.error || Object.keys($page.props.errors).length > 0) && show"
                class="flex items-center justify-between max-w-3xl mb-8 bg-red-500 rounded-lg"
                @click="show = false"
            >
                <div class="flex w-full max-w-sm mx-auto overflow-hidden bg-white rounded-lg shadow-md dark:bg-gray-800">
                    <div class="flex items-center justify-center w-12 bg-red-500">
                        <ErrorIcon class="w-6 h-6 text-white fill-current" />
                    </div>

                    <div class="px-4 py-2 -mx-3">
                        <div class="mx-3">
                            <span class="font-semibold text-red-500 dark:text-red-400">Error</span>
                            <p
                                v-if="$page.props.flash.error"
                                class="text-sm text-gray-600 dark:text-gray-200"
                            >
                                {{ $page.props.flash.error }}
                            </p>
                            <p
                                v-else
                                class="text-sm text-gray-600 dark:text-gray-200"
                            >
                                <span v-if="Object.keys($page.props.errors).length === 1">There is one form error.</span>
                                <span v-else>There are {{ Object.keys($page.props.errors).length }} form errors.</span>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
import SuccessIcon from './Icons/SuccessIcon.vue';
import ErrorIcon from './Icons/ErrorIcon.vue';

export default {
    name: 'FlashMessages',
    components: {
        SuccessIcon,
        ErrorIcon,
    },
    data() {
        return {
            show: false,
        };
    },
    watch: {
        '$page.props.flash': {
            handler() {
                this.show = true;
            },
            deep: true,
        },
        show: {
            handler(newVal) {
                if (newVal) {
                    setTimeout(() => {
                        this.show = false;
                    }, 5000);
                }
            },
        },
    },
    mounted() {
        this.show = true;
    },
};
</script>
